/**
 * The door's plays, read for the deck and the card. Pure, so the wording is
 * tested: this week against last, and fourteen days as bars with the best
 * day named.
 */
export function weekLine(week: number, prev: number): string {
  if (week === 0 && prev === 0) return '';
  if (prev === 0) return `${week.toLocaleString()} play${week === 1 ? '' : 's'} this week`;
  const delta = Math.round(((week - prev) / prev) * 100);
  const arrow = delta > 0 ? '↑' : delta < 0 ? '↓' : '→';
  return `${week.toLocaleString()} play${week === 1 ? '' : 's'} this week · ${arrow} ${Math.abs(delta)}% on last week`;
}

export interface DayBar { day: string; plays: number; height: number; best: boolean }

/** Fourteen bars ending today, empty days as zero; the best day marked (the first when tied). */
export function dayBars(byDay: { day: string; plays: number }[], today: Date = new Date()): DayBar[] {
  const have = new Map(byDay.map((d) => [d.day, d.plays]));
  const out: DayBar[] = [];
  for (let i = 13; i >= 0; i--) {
    const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    out.push({ day: key, plays: have.get(key) ?? 0, height: 0, best: false });
  }
  const top = Math.max(0, ...out.map((b) => b.plays));
  if (top > 0) {
    for (const b of out) b.height = Math.round((b.plays / top) * 100);
    out.find((b) => b.plays === top)!.best = true;
  }
  return out;
}
